import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////

export const Hacks: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/
	return (
		<div>
			<Link
				to={'/hacks'}
				className={`flex flex-col items-center gap-2 rounded-[20px] flex-1`}
			>
				<img
					className="drop-shadow-lg"
					src={process.env.VITE_HACKS_IMAGE}
					width={'35px'}
				/>
				<p className="text-xs font-semibold">{t('hacks.title')}</p>
			</Link>
		</div>
	);
};
